/**
 * Shared PHI field sets for client-side blurring.
 * These MUST match the backend GraphQL model PHI metadata.
 */

export const CONTACT_PHI_FIELDS = new Set([
  `name`,
  `preferredName`,
  `patientName`,
  `email`,
  `birthDate`,
  `cellPhone`,
  `homePhone`,
  `workPhone`,
  `otherPhone`,
  `addressLine1`,
  `addressLine2`,
  `city`,
  `state`,
  `zip`,
])

export const CALL_PHI_FIELDS = new Set([
  `callerId`,
  `patientNames`,
  `callerPhone`,
  `trackingNumber`,
  `businessPhone`,
  `ai`,
  `patients`,
  `note`,
  `city`,
])

export const USER_PHI_FIELDS = new Set([`name`, `phone`, `email`])

export function isPhiField(model: `contact` | `call` | `user`, field: string): boolean {
  switch (model) {
    case `contact`:
      return CONTACT_PHI_FIELDS.has(field)
    case `call`:
      return CALL_PHI_FIELDS.has(field)
    case `user`:
      return USER_PHI_FIELDS.has(field)
  }
}

export function phiCellStyle(field: string, model: `contact` | `call` | `user` = `contact`): string {
  return isPhiField(model, field) ? `phi-wrapper` : ``
}
